<div
  *ngIf="!isDone; else uploadDone"
  class="fixed left-0 right-0 top-0 z-30 flex h-[calc(100%-1rem)] max-h-full w-full animate-fadeUp items-center justify-center overflow-y-auto overflow-x-hidden duration-500 md:inset-0"
  id="default-modal">
  <div
    class="fixed bottom-0 h-[90vh] w-[100vw] overflow-hidden rounded-t-[10px] bg-white md:relative md:h-auto md:w-full md:max-w-[800px] md:bg-transparent">
    <!-- Modal content -->
    <div class="relative bg-white md:rounded-[24px]">
      <!-- Modal header -->
      <div class="p-6">
        <div class="flex items-center">
          <button
            (click)="closeModalKyc()"
            class="mr-6"
            app-icon-button
            name="x"
            size="sm"></button>
          <div
            *ngIf="stepToUpload !== 1"
            class="grid h-0.5 flex-1 gap-x-1"
            [ngClass]="useFinPass || steps.length === 3 ? 'grid-cols-3' : 'grid-cols-2'">
            <span
              *ngFor="let step of steps"
              class="rounded-[2px]"
              [ngClass]="step.id <= currentStep ? 'bg-primary-600' : 'bg-neutral-100'">
            </span>
          </div>
        </div>
        <ng-container *ngFor="let step of steps">
          <p
            translate
            *ngIf="currentStep === step.id"
            class="prose prose-display-lg mt-6 font-semibold">
            lbl.{{ step.title }}
          </p>
          <p *ngIf="currentStep === step.id" class="mt-3 text-sm text-neutral-500" translate>
            lbl.{{ step.subtitle }}
          </p></ng-container
        >
        <!-- <ng-container *ngIf="stepToUpload === 1">
          <p translate class="prose prose-display-lg mt-6 font-semibold">lbl.proofOfAddress</p>
          <p class="mt-3 text-sm text-neutral-500" translate>
            lbl.frontOfIdCardSubTitle
          </p></ng-container
        > -->
      </div>
      <!-- Modal body -->
      <div class="flex flex-col items-center justify-center px-6 pb-6 pt-3">
        <div
          *ngIf="uploadError"
          class="mb-5 flex w-full items-center gap-3 rounded-xl bg-primary-100 p-3 md:w-[343px]">
          <app-icon name="alert-circle-solid" color="#F00125"></app-icon>
          <div>
            <p class="text-sm font-medium">{{ errorMsg }}</p>
          </div>
        </div>
        <app-unexpected-error
          class="mx-auto mb-10 min-w-[300px] max-w-[500px]"
          *ngIf="unexpectedError$ | async" />
        <app-upload
          class="w-full"
          (fileUploaded)="onUploadedFile($event)"
          [stepChange]="currentStep"></app-upload>
      </div>
    </div>
  </div>
</div>
<ng-template #uploadDone>
  <div
    class="fixed left-0 right-0 top-0 z-50 flex h-[calc(100%-1rem)] max-h-full w-full animate-fadeUp items-center justify-center overflow-y-auto overflow-x-hidden duration-500 md:inset-0"
    id="default-modal">
    <div
      [ngClass]="isWebview ? 'h-[calc(100%-32px)]' : 'h-full'"
      class="fixed bottom-0 w-full overflow-hidden bg-white md:relative md:h-auto md:w-full md:max-w-[800px] md:rounded-t-[10px] md:bg-transparent">
      <div class="relative flex h-full flex-col bg-white md:rounded-[24px]">
        <div class="grid flex-1 place-items-center px-6 pt-10">
          <div class="flex flex-col items-center justify-center">
            <figure class="mb-10 h-[200px] w-[200px] overflow-hidden">
              <img
                src="assets/images/all-done.png"
                class="h-full w-full object-cover"
                alt="All done" />
            </figure>
            <h3 class="prose prose-display-lg mb-3 font-semibold" translate>lbl.allDone</h3>
            <p translate>{{ allDoneMessage }}</p>
          </div>
        </div>
        <div class="mt-auto px-6 py-10">
          <div class="flex items-center justify-end">
            <button (click)="handleOnSuccess()" app-button>
              <span translate>{{
                router.url === "/auth/sign-up/new-remitter" ? "btn.backToLogin" : "lbl.back"
              }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<div class="fixed inset-0 z-20 bg-black bg-opacity-50"></div>
